/** Topes de carga efectivos servidos por el backend para el tenant activo. */
import { useEffect, useState } from 'react';
import { mobileApiClient } from '@/services/mobileApiClient';

export type UploadLimits = {
  attachmentMaxSizeMb: number;
  attachmentBatchMaxFiles: number;
};

export const DEFAULT_UPLOAD_LIMITS: UploadLimits = {
  attachmentMaxSizeMb: 10,
  attachmentBatchMaxFiles: 5,
};

type UploadLimitsResponse = {
  attachment_max_size_mb: number;
  attachment_batch_max_files: number;
};

export function useUploadLimits(): UploadLimits {
  const [limits, setLimits] = useState<UploadLimits>(DEFAULT_UPLOAD_LIMITS);

  useEffect(() => {
    let active = true;
    mobileApiClient
      .get<UploadLimitsResponse>('/api/v1/settings/upload-limits')
      .then(({ data }) => {
        if (!active) return;
        setLimits({
          attachmentMaxSizeMb: data.attachment_max_size_mb,
          attachmentBatchMaxFiles: data.attachment_batch_max_files,
        });
      })
      .catch(() => {
        // Sin red o sin sesion se mantienen los defaults.
      });
    return () => {
      active = false;
    };
  }, []);

  return limits;
}
